export function formatCount(value: number): string {
  return value.toLocaleString('pt-BR');
}

/** Data longa. O valor precisa trazer horário ou fuso, senão o dia vira o anterior no Brasil. */
export function formatLongDate(value: string): string {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleDateString('pt-BR', { day: 'numeric', month: 'long', year: 'numeric' });
}
